export default __webpack_public_path__ + "static/media/redjoker.0a684154.png";